'use client'

import React from 'react'
import Link from 'next/link'
import { useLanguage } from '@contexts/LanguageContext'

const VolunteerCTA: React.FC = () => {
  const { t } = useLanguage()

  return (
    <section className="volunteer-cta-modern">
      <div className="volunteer-bg-pattern"></div>
      <div className="container">
        <div className="volunteer-grid">
          {/* Left: Volunteer */}
          <div className="volunteer-content-modern">
            <span className="volunteer-label">{t('getInvolved')}</span>
            <h2 className="volunteer-title-modern">
              <span className="gradient-text">{t('closingCtaTitle')}</span>
            </h2>
            <p className="volunteer-desc-modern">{t('volunteerCtaDesc')}</p>

            <h3 className="volunteer-subtitle-modern">{t('fieldVolunteerTitle')}</h3>
            <p className="volunteer-desc-modern">{t('fieldVolunteerDesc')}</p>

            <div className="volunteer-features">
              <div className="feature-item">
                <div className="feature-icon">📖</div>
                <div>
                  <strong>{t('academicRoles')}</strong>
                  <p>{t('academicRolesDesc')}</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📋</div>
                <div>
                  <strong>{t('nonAcademicRoles')}</strong>
                  <p>{t('nonAcademicRolesDesc')}</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🤝</div>
                <div>
                  <strong>{t('whoCanJoin')}</strong>
                  <p>{t('whoCanJoinDesc')}</p>
                </div>
              </div>
            </div>

            <div className="volunteer-actions-modern">
              <Link href="/volunteer" className="btn-volunteer-primary">
                <span>{t('applyToVolunteer')}</span>
                <span className="btn-arrow">→</span>
              </Link>
            </div>
          </div>

          {/* Right: Partner */}
          <div className="volunteer-stats-panel">
            <div className="stats-panel-header">
              <h3>{t('partnerWithUs')}</h3>
            </div>
            <p className="partner-panel-text">{t('partnershipDesc')}</p>
            <p className="partner-panel-text">{t('partnershipDesc2')}</p>
            <Link href="/partner" className="btn-cta-primary partner-panel-btn">
              {t('becomeAPartner')} →
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default VolunteerCTA
